<template>
  <div class="app-official-site">
    <p>Official State of Rhode Island website</p>
  </div>
</template>

<script setup>
defineOptions({
  name: 'OfficialSite',
});
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/official-site";
</style>

